import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 81.579 81.579",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<g fill="rgba(83,122,161,.1)" stroke="#243E81" stroke-width="2"> <circle cx="40.79" cy="40.79" r="40.79" stroke="none"/> <circle cx="40.79" cy="40.79" r="39.29" fill="none"/> </g> <path d="M55.807 25.38a18.3 18.3 0 0 1-3.471.3 25.7 25.7 0 0 1-10.711-2.28l-.892-.4-.2.1-.694.3a25.95 25.95 0 0 1-10.709 2.278 25 25 0 0 1-3.471-.2l-2.678-.594.1 2.678c.693 30.938 16.858 32.726 17.552 32.726h.4c.694-.1 16.859-1.785 17.553-32.726l-.1-2.578zM33.485 47.748l14.614-14.219m0 14.219L33.485 33.134" stroke="#243E81" fill="none"/>' }
  })
);